import React from "react";
import { BsDot } from "react-icons/bs";
import { Link } from "react-router-dom";
import { ResponceMain } from "../OptionRes/ResStyles";

const SupportRes = () => {
  return (
    <ResponceMain>
      <div className="space-between">
        <h3>24/7 Customer Support</h3>
      </div>
      <ul>
        <li>
          <BsDot className="dot" />
          All time support
        </li>
        <li>
          <BsDot className="dot" />
          Software after-sales support
        </li>
        <li>
          <BsDot className="dot" />
          Long-term technical-support
        </li>
        <li>
          <BsDot className="dot" />
          Call On +91 8888830536
        </li>
      </ul>
      <Link to="/support">
        <div className="button">See Details</div>
      </Link>
    </ResponceMain>
  );
};

export default SupportRes;
